import axios from 'axios';
import { settings } from '@/plugins/settings';

export const orderService = {
  /**
   * @description Returns the total count of orders matching the given filters.
   */
  fetchOrdersCount(filters: any): Promise<number> {
    return axios({ url: settings.endpoint + 'orders/count', method: 'GET', params: filters }).then((response: any) => {
      if (response && response.data && response.data.data) return response.data.data.count || 0;
      if (response && response.data && response.data.count !== undefined) return response.data.count || 0;
      return 0;
    });
  },

  fetchOrderStatistics(filters: any): Promise<{ by_day: Array<{period: string, count: number}>, by_week: Array<{period: string, count: number}>, by_month: Array<{period: string, count: number}> }> {
    return axios({ url: settings.endpoint + 'orders/statistics', method: 'GET', params: filters }).then((response: any) => {
      const data = (response && response.data && response.data.data) ? response.data.data : (response && response.data ? response.data : {});
      return {
        by_day: Array.isArray(data.by_day) ? data.by_day : [],
        by_week: Array.isArray(data.by_week) ? data.by_week : [],
        by_month: Array.isArray(data.by_month) ? data.by_month : [],
      };
    });
  },

  /**
   * @description Endpoint that exports data from orders, can be filtered and limited to 1000 rows to avoid timeouts
   */
  exportOrders(filters: any): Promise<any[]> {
    return axios({ url: settings.endpoint + 'orders/', method: 'GET', params: { ...filters, page: 0 } }).then((response: any) => {
      if (response && response.data && response.data.data) return response.data.data;
      if (response && Array.isArray(response.data)) return response.data;
      return [];
    });
  },
};
